import React from "react";
import Footer from "Components/Common/Footer/Footer";
import Header from "Components/Common/Header/Header";
import UserList from "Components/Common/UserList/List/UserList";

const Networks = () => {
  const eventId = localStorage.getItem("eventId");

  return (
    <>
      <Header moduleName={"networks"} />
      <section className="inner_sec">
        <div className="container">
          <UserList
            eventId={eventId}
            showTitle={true}
            componentName={"networks"}
          />
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Networks;
